import { createFileRoute } from '@tanstack/react-router';
import { StartPage } from '../../features/start/start-page.tsx';

// Start here overview (T33b): my progress, the lessons and the quiz.
export const Route = createFileRoute('/_authed/start/')({
  component: StartPage,
});
